<!-- MFITTで予約期限を過ぎて座席指定/予約に進もうとした場合 -->
<template>
  <ItemDialog ref="canNotReserveBecauseOverLimit" image-type="alert">
    <template #content-area>
      <p class="text-center">
        期限を過ぎたため予約はできません。<br />
        予約できるのは発車45分前までです。
      </p>
    </template>
    <template #button-area>
      <ItemButton
        label="閉じる"
        action-type="btn-primary"
        @clicked="closeDialog()"
      />
    </template>
  </ItemDialog>
</template>

<script>
import { ref } from "vue";

export default {
  name: "DialogCanNotReserveBecauseOverLimit",
  props: {
    closeButtonClicked: {
      type: Function,
      required: false,
      default: null,
    },
  },
  setup(props) {
    const canNotReserveBecauseOverLimit = ref(null);

    const openDialog = () => {
      canNotReserveBecauseOverLimit.value.open();
    };

    const closeDialog = () => {
      if (props.closeButtonClicked == null) {
        canNotReserveBecauseOverLimit.value.close();
      } else {
        props.closeButtonClicked();
      }
    };

    return {
      canNotReserveBecauseOverLimit,
      openDialog,
      closeDialog,
    };
  },
};
</script>
